@for (item of items; track item.href; let i = $index) {
  @if (item.href) {
    <a [routerLink]="item.href" class="w-full grow py-2">
      <ng-container *ngTemplateOutlet="content; context: { item: item, i: i }" />
    </a>
  } @else {
    <button class="w-full grow py-2" (click)="onSelectMenuItem(i)">
      <ng-container *ngTemplateOutlet="content; context: { item: item, i: i }" />
    </button>
  }
}
<ng-template #content let-item="item" let-i="i">
  <div class="relative flex min-h-[40px] grow flex-col justify-center px-4">
    <button
      class="flex w-full items-center px-4 py-2 text-[13px] font-[550] leading-5 text-text-1 active:bg-surface active:font-[650]"
    >
      <!-- <ng-icon class="shrink-0" [svg]="item.icon" size="16px" /> -->
      <mat-icon class="shrink-0 text-base">{{ item.icon }}</mat-icon>
      <span class="ml-4 w-full grow text-left">
        {{ item.name }}
      </span>

      @if (badgeCount(item); as count) {
        <span
          class="ml-2 min-w-[20px] shrink-0 rounded-full bg-brand-600 px-1.5 text-center text-xs leading-5 text-white"
          data-cy="sidemenu-badge"
        >
          {{ count }}
        </span>
      }
    </button>
    @if (selectedMenuItem === i) {
      <div @submenuTransition>
        <div class="flex w-full flex-col">
          @for (menuItem of item.menus; track menuItem.href; let index = $index) {
            <a
              [routerLink]="menuItem.href"
              class="flex h-10 min-w-[116px] items-center px-11 hover:bg-surface"
              [ngClass]="index === selectedSubmenuItem ? 'bg-surface' : ''"
            >
              @if (index === selectedSubmenuItem) {
                <svg
                  [style.top.px]="40 + 40 * index"
                  class="absolute left-[37px]"
                  width="12"
                  height="19"
                  viewBox="0 0 12 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.01353e-07 0H1.5V9.95C1.5 10.8025 1.50058 11.3967 1.53838 11.8593C1.57547 12.3132 1.6446 12.574 1.74524 12.7715C1.96095 13.1948 2.30516 13.539 2.72852 13.7548C2.92604 13.8554 3.18681 13.9245 3.64068 13.9616C4.10331 13.9994 4.69755 14 5.55 14H8.93934L7.21967 12.2803C6.92678 11.9874 6.92678 11.5126 7.21967 11.2197C7.51256 10.9268 7.98744 10.9268 8.28033 11.2197L11.2803 14.2197C11.5732 14.5126 11.5732 14.9874 11.2803 15.2803L8.28033 18.2803C7.98744 18.5732 7.51256 18.5732 7.21967 18.2803C6.92678 17.9874 6.92678 17.5126 7.21967 17.2197L8.93934 15.5H5.51788C4.70505 15.5 4.04944 15.5 3.51853 15.4566C2.9719 15.412 2.49175 15.3176 2.04754 15.0913C1.34193 14.7317 0.768252 14.1581 0.408726 13.4525C0.182386 13.0082 0.0880253 12.5281 0.0433638 11.9815C-1.31503e-05 11.4506 -7.42804e-06 10.795 2.01353e-07 9.98212V0Z"
                    fill="#B5B5B5"
                  />
                </svg>
              }
              <span
                class="text-[13px] font-[550] leading-5"
                [style.color]="index === selectedSubmenuItem ? '#303030' : '#616161'"
              >
                {{ menuItem.label }}
              </span>
              @if (index === selectedSubmenuItem) {
                <div
                  [style.top.px]="28"
                  [style.height.px]="12 + 40 * index"
                  class="absolute left-[37px] w-[1.4px] bg-[#B5B5B5]"
                ></div>
              }
            </a>
          }
        </div>
      </div>
    }
  </div>
</ng-template>
